var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{class:['vst-loading-row', `vst-loading-row-${_vm.randNum}`],attrs:{"colspan":_vm.columnsLength}},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }